import React from 'react';
import Button from '../Button/Button';
import Modal from '../Modal/Modal';
 
const TimeoutModal = ({ showModal, togglePopup, handleStayLoggedIn }) => {
  return <Modal show={showModal} toggle={togglePopup} keyboard={false} backdrop="static">
    <h1>Session Timeout!</h1>
    <p>
    Due to inactivity on the HealthSafe ID Admin Tool, your session will end in 1 minute. Please click the button below to extend your session.
    </p>
    <Button btnType="Search" clicked={handleStayLoggedIn}>Stay Logged In</Button>
  </Modal>
}
 
export default TimeoutModal;